import { Injectable } from '@angular/core';
import * as turf from '@turf/turf';
// @ts-ignore
import { LngLatBounds, LngLat } from '!mapbox-gl';
import { BBOXArray, BBOX } from '../types/@types/sl-v-types';

export function BBoxToLngLatBounds(bbox: BBOX|BBOXArray):LngLatBounds | undefined {
  const bboxArray = typeof(bbox) === 'string' ? bbox.split(',') : bbox;
  if(bboxArray.length < 4) return undefined;
  const pt1 = new LngLat(Number(bboxArray[0]), Number(bboxArray[1]));
  const pt2 = new LngLat(Number(bboxArray[2]), Number(bboxArray[3]));
  if (pt1.lng < -180) pt1.lng = -180.0;
  if (pt1.lng > 180) pt1.lat = 180.0;
  if (pt1.lat < -90) pt1.lat = -90.0;
  if (pt1.lat > 90) pt1.lat = 90.0;
  if (pt2.lng < -180) pt2.lng = -180.0;
  if (pt2.lng > 180) pt2.lat = 180.0;
  if (pt2.lat < -90) pt2.lat = -90.0;
  if (pt2.lat > 90) pt2.lat = 90.0;

  const bounds = new LngLatBounds(pt1, pt2);
  return bounds;
}

@Injectable({
  providedIn: 'root'
})
export class GeoService {

  constructor() { }
  BBoxToLngLatBounds(bbox: BBOXArray): LngLatBounds | undefined {
    return BBoxToLngLatBounds(bbox);
    /*
    const pt1 = new LngLat(Number(bbox[0]), Number(bbox[1]));
    const pt2 = new LngLat(Number(bbox[2]), Number(bbox[3]));
    if (pt1.lng < -180) pt1.lng = -180.0;
    if (pt1.lng > 180) pt1.lat = 180.0;
    if (pt1.lat < -90) pt1.lat = -90.0;
    if (pt1.lat > 90) pt1.lat = 90.0;
    if (pt2.lng < -180) pt2.lng = -180.0;
    if (pt2.lng > 180) pt2.lat = 180.0;
    if (pt2.lat < -90) pt2.lat = -90.0;
    if (pt2.lat > 90) pt2.lat = 90.0;

    const bounds = new LngLatBounds(pt1, pt2);
    return bounds;
    */
  }
  LngLatBoundsToBBoxArray(bounds: LngLatBounds): BBOXArray {
    return [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];
  }
  LngLatBoundsToBBoxString(bounds: LngLatBounds): BBOX {
    return this.LngLatBoundsToBBoxArray(bounds).join(',');
  }

  IncreaseLngLatBoundsByPercent(bounds: LngLatBounds, percentage: number = .25): LngLatBounds {
    const minLng: number = bounds.getWest();
    const minLat: number = bounds.getNorth();
    const maxLng: number = bounds.getEast();
    const maxLat: number = bounds.getSouth();
    const center: LngLat = bounds.getCenter();
    const width: number = maxLng - minLng;
    const height: number = maxLat - minLat;
    const adjWidth = width + (width * percentage);
    const adjHeight = height + (height * percentage);
    const adjHalfWidth = adjWidth / 2.0;
    const adjHalfHeight = adjHeight / 2.0;
    const adjMinLng = center.lng - adjHalfWidth;
    const adjMinLat = center.lat - adjHalfHeight;
    const adjMaxLng = center.lng + adjHalfWidth;
    const adjMaxLat = center.lat + adjHalfHeight;
    return new LngLatBounds([adjMinLng, adjMinLat, adjMaxLng, adjMaxLat]);
  }
  ScaleBounds(bounds: LngLatBounds, scaleBy: number): LngLatBounds {
    const turfAdjPoly = turf.transformScale(
      this.BoundsToTurf(bounds), scaleBy, { origin: 'center' });
    const turfBbox: BBOXArray = turf.bbox(turfAdjPoly) as BBOXArray;
    return this.BBoxToLngLatBounds(turfBbox);
  }
  BoundsToTurf(bounds: LngLatBounds): any {
    const poly = turf.polygon([[
      bounds.getNorthWest().toArray(),
      bounds.getNorthEast().toArray(),
      bounds.getSouthEast().toArray(),
      bounds.getSouthWest().toArray(),
      bounds.getNorthWest().toArray()
    ]]);
    return poly;
  }
}
